import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function() {
	var sections = document.querySelectorAll('.service-specialties');
	var hoverDelay = 150;

	sections.forEach(function(section) {
		var listItems = section.querySelectorAll('.specialties-list li');
		var images = section.querySelectorAll('.specialty-image');
		var hoverTimer = null;

		listItems.forEach(function(li) {
			li.addEventListener('mouseenter', function() {
				var el = this;
				clearTimeout(hoverTimer);
				hoverTimer = setTimeout(function() {
					var index = el.getAttribute('data-index');

					listItems.forEach(function(item) { item.classList.remove('active'); });
					el.classList.add('active');

					images.forEach(function(img) { img.classList.remove('active'); });
					var target = section.querySelector('.specialty-image[data-index="' + index + '"]');
					if (target) target.classList.add('active');
				}, hoverDelay);
			});

			li.addEventListener('mouseleave', function() {
				clearTimeout(hoverTimer);
			});
		});
	});

	// Mobile Swiper
	document.querySelectorAll('.specialties-mobile').forEach(function(mobile) {
		var swiper = new Swiper(mobile.querySelector('.specialties-swiper'), {
			centeredSlides: true,
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 6,
			speed: 500,
		});

		mobile.querySelector('.next').addEventListener('click', function() {
			swiper.slideNext(500);
		});

		mobile.querySelector('.prev').addEventListener('click', function() {
			swiper.slidePrev(500);
		});
	});
});
